// extracted by mini-css-extract-plugin
module.exports = {"borderBox":"borderBox___oZtXC","flexCenter":"flexCenter___27Hvf","closeIcon":"closeIcon___2jrKR"};